import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { CheckStampService } from '../services/check-stamp.service';
import { BsModalService, ModalDirective } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { BatchstampService } from '../../../qrcode/batchstamp/batchstamp.service';
import { environment } from '../../../../../../environments/environment';
import { AgencyService } from '../../../qrcode/agencyListing/services/agency.service';
import { EvsAddressService } from '../../../../../common/services/EvsAddress.service';
import { WarningInspection } from '../../../qrcode/warning-overflow/services/warning-inspection';
import * as moment from 'moment';
import { UploadService } from '../../../../../common/services/Upload.service';
import { EvsStampService } from '../../../../../common/services/EvsStamp.service';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

declare var $: any;

@Component({
  selector: 'app-stamp-product',
  templateUrl: './stamp-product.component.html',
  styleUrls: ['./stamp-product.component.css'],
  providers: [CheckStampService, AgencyService, WarningInspection, EvsStampService,],
})
export class StampProductComponent implements OnInit {
  loading_page = false;
  has_data = true;
  data;
  data_verify;
  code = '123';
  // loại tem : true là nhà sản xuất, fale là nhà được phân phối
  type_stamp: boolean;
  pageIndexScanErr = 1;
  pageSizeScanErr = 10;
  // ==================== lich su phan phoi ================ //
  pageIndexDistribution = 1;
  pageSizeDistribution = 10;
  bodyDistribution;
  data_distribution = [];
  data_scan_errors = [];
  total_distribution = 0;
  total_scan_errors = 0;
  public pager: any;
  public currentPage: number = 1;
  public pageSize: number = 10;
  public totalPage: number = 0;
  // ==================== end  lich su phan phoi ================ //

  // ==================== lich su quet ======================= //
  queryScan;
  pageIndexScan = 1;
  pageSizeScan = 10;
  data_scan = [];
  total_scan = 0;
  // ==================== end lich su quet =================== //

  // ============ tra tem ================= //end
  note_return = '';
  valid_note_return = false;
  // ============  tra tem ================= //

  // ==================== ds canh bao thi truong =========== //
  pageIndexWarning = 1;
  pageSizeWarning = 10;
  queryWarning;
  data_warning = [];
  total_warning = 0;
  // ==================== end ds canh bao thi truong ======== //
  form = this.fb.group({});
  listBatches = [];
  actions = [
    {
      label: 'Xác nhận',
      value: 1,
    },
    {
      label: 'Phân phối',
      value: 2,
    },
    {
      label: 'Trả hàng',
      value: 3,
    },
  ];
  totalBatchPage = 10;
  batchCurrentPage = 1;
  message = 'Không tìm thấy thông tin tem';
  has_baohanh = true;
  logsScanGuarantee = [];
  logs_BH = {
    currentPage: 1,
    has_list: [],
  };
  listDistribution = [];
  data_map = [];
  data_map_warning = [];
  lat;
  lng;
  zoom = 15;
  activeTab = 1;
  isDistribution: Boolean = false;
  isList: Boolean = true;
  load_map_distrivution = true;
  bsModalDownload: BsModalRef;
  @ViewChild("boxStampDistribution") boxStampDistribution;
  @ViewChild('checkWarning') checkWarning: ModalDirective;
  @ViewChild('blockModal') blockModal: ModalDirective;
  @ViewChild('retutn') retutn: ModalDirective;
  // block tem
  note_block: string;
  disable_block = false;
  // end block tem

  // canh bao thi truong
  valid_agency = false;
  warning_count = 0;
  note_warning = '';
  agency_detail;
  body: any;
  disable_warning = false;
  cities = [];
  districts = [];
  validProvinceId = false;
  validDistrict = false;
  address = '';

  // end canh bao thi truong
  after_create_warning = false;
  langChangeSub: Subscription;
  /* Tuanba:12/4/2022: Mekongas*/
  source = Number(JSON.parse(localStorage.getItem("User")).source)
  constructor(
    private fb: FormBuilder,
    private checkStampService: CheckStampService,
    private toastr: ToastrService,
    private batchService: BatchstampService,
    private agencyService: AgencyService,
    public addressService: EvsAddressService,
    private warningInspection: WarningInspection,
    private upload: UploadService,
    private stampService: EvsStampService,

    private modalService: BsModalService,
    private translate: TranslateService,
  ) { }
  ngOnInit() {
    this.isDistribution = false;
    this.isList = true;
    const agency = $('#agency');
    agency.select2({
      placeholder: this.translate.instant('CHON_DAI_LY_CANH_BAO'),
      allowClear: false,
      minimumInputLength: 3,
      ajax: {
        delay: 1000,
        url: `${environment.qrcode_url}/agencies`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('Access-Token')}`,
          'Content-Type': 'application/json',
        },
        dataType: 'json',
        data: function (params) {
          if (params.term) {
            return {
              name: params.term,
              offset: 0,
              limit: 50,
            };
          }
          return {
            offset: 0,
            limit: 50,
          };
        },
        processResults: function (data) {
          return {
            results: data.data.items.map((item) => {
              return {
                text: item.name,
                id: item.id,
              };
            }),
          };
        },
      },
    });
    const that = this;
    agency.on('select2:open', function () {
      that.valid_agency = false;
    });
    agency.on('select2:close', function () {
      const val = agency.val();
      if (!val) {
        that.valid_agency = true;
        return;
      }
      that
        .getTotalWarning(val)
        .then((res) => {
          if (res.code === 1) {
            that.warning_count = res.data;
            return;
          }
          that.warning_count = 0;
        })
        .catch((err) => {
          that.warning_count = 0;
        });
      that.getDetilAgency(val).then((res) => {
        if (res.code === 1) {
          that.agency_detail = res.data;
        }
      });
    });
    this.getFromArea();
    const cities = $('#citiesProduct');
    cities.select2({ placeholder: this.translate.instant('TINH_THANH'), allowClear: false });
    cities.on('select2:select', function (e) {
      $('.select2-selection__rendered').removeAttr('title');
      $('#districtProduct').val(null).trigger('change');
      const id = e.target.value;
      that.getDistrict(id);
    });
    cities.on('select2:open', function () {
      that.validProvinceId = false;
    });
    cities.on('select2:close', function (e) {
      const id = e.target.value;
      if (!id) {
        that.validProvinceId = true;
      }
    });
    const district = $('#districtProduct');
    district.select2({ placeholder: this.translate.instant('QUAN_HUYEN'), allowClear: false });
    district.on('select2:open', function () {
      that.validDistrict = false;
    });
    district.on('select2:close', function (e) {
      const id = e.target.value;
      if (!id) {
        that.validDistrict = true;
      }
    });

    $('#note_return2').on('change keyup paste', function () {
      that.valid_note_return = false;
      if (!this.value) {
        that.valid_note_return = true;
      }
    });
    this.langChangeSub = this.translate.onLangChange.subscribe(() => {
      if (agency.data('select2')) {
        const v = agency.val();
        agency.select2('destroy').select2({
          placeholder: this.translate.instant('CHON_DAI_LY_CANH_BAO'),
          allowClear: false,
          minimumInputLength: 3,
          ajax: {
            delay: 1000,
            url: `${environment.qrcode_url}/agencies`,
            headers: {
              Authorization: `Bearer ${localStorage.getItem('Access-Token')}`,
              'Content-Type': 'application/json',
            },
            dataType: 'json',
            data: function (params) {
              if (params.term) {
                return { name: params.term, offset: 0, limit: 50 };
              }
              return { offset: 0, limit: 50 };
            },
            processResults: function (data) {
              return {
                results: data.data.items.map((item) => ({ text: item.name, id: item.id })),
              };
            },
          },
        });
        if (v) {
          agency.val(v).trigger('change');
        }
      }
      if (cities.data('select2')) {
        const v = cities.val();
        cities.select2('destroy').select2({ placeholder: this.translate.instant('TINH_THANH'), allowClear: false });
        if (v) {
          cities.val(v).trigger('change');
        }
      }
      if (district.data('select2')) {
        const v = district.val();
        district.select2('destroy').select2({ placeholder: this.translate.instant('QUAN_HUYEN'), allowClear: false });
        if (v) {
          district.val(v).trigger('change');
        }
      }
    });
  }

  ngOnDestroy() {
    if (this.langChangeSub) {
      this.langChangeSub.unsubscribe();
    }
  }

  loadData(data) {
    this.data_map = [];
    this.data_map_warning = [];
    this.has_data = true;
    this.after_create_warning = false;
    // owner = true: sản xuất, = false : phân phối
    this.type_stamp = data.owner;
    this.data = data;
    let serial = this.data.serial;
    serial = serial.split('-');
    const id = serial[serial.length - 1];
    const format = '000000';
    // this.data.serial =
    //   serial[0] +
    //   "-" +
    //   format.substring(0, format.length - id.toString().length) +
    //   id;

    serial[serial.length - 1] =
      format.substring(0, format.length - id.toString().length) + id;
    console.log(serial);

    this.data.serial = serial.join('-');
    const idStart = this.data.idStart;
    this.data.idStart =
      format.substring(0, format.length - idStart.toString().length) + idStart;
    console.log(this.data);
    const list = [];
    if (this.data) {
      this.checkStampService.getValidator(this.data.serial).subscribe(
        (res) => {
          this.data_verify = undefined;
          if (res.code === 1) {
            this.data_verify = res.data;
            return;
          }
        },
        (error) => {
          this.data_verify = undefined;
        }
      );
      const services = this.data.service;
      if (services) {
        if (services.includes('CG')) {
          list.push('CHONG_GIA');
        }
        if (services.includes('BH')) {
          list.push('BAO_HANH');
        }
        if (services.includes('TH')) {
          list.push('TRAN_HANG');
        }
        if (services.includes('DD')) {
          list.push('DINH_DANH');
        }
      }
      this.loadHistoryDistribution();
      this.loadScanErrors();
      this.loadHistoryScan();
      this.loadListWarning();
      this.loadHistoryGuarantee();
      setTimeout(() => {
        this.getAllWarningMarket();
      }, 2000);
    }
    this.data.list_services = list;
  }

  // =============== lich su phan phoi ================= //
  // tslint:disable-next-line:member-ordering
  public toLocation = [];

  loadHistoryDistribution() {
    console.log('ádasdddddddđ')

    this.bodyDistribution = {
      serial: this.data.serial,
      page: this.pageIndexDistribution,
      page_size: this.pageSizeDistribution,
      owner: this.data.owner,
    };
    this.checkStampService.getStampHistory(this.bodyDistribution).subscribe(
      async (res) => {
        if (res.code === 1) {
          this.data_distribution = res.data.items;
          this.data_distribution.map((item, index) => {
            const arr = [];
            const arr_keys = ['fromProvince', 'fromDistrict', 'fromAddress'];
            arr_keys.map((key) => {
              if (item[key] === null) {
                item[key] = 'Không xác định';
              }
            });
            console.log('ádasdASditem', item.toLocationData)
            item.toLocationData.map((val) => {
              const address = val.toAddress ? val.toAddress + ' - ' : '';
              const toDistrictArea = val.toDistrictArea ? val.toDistrictArea : '';
              const toProvincesArea = val.toProvincesArea ? val.toProvincesArea : '';
              const result = address + toDistrictArea + ' - ' + toProvincesArea;
              arr.push(result);
              item.toLocationDataConvert = arr;
            })

            if (item.toAgency === null) {
              item.toAgency = 'Khu vực';
              const list_province_Id = item.location.item.provinceIds;
              const list_province_name = [];
              this.cities.map((city) => {
                if (list_province_Id.includes(city.id)) {
                  list_province_name.push(city.value);
                }
              });
              item.to_list_provinceName = 'Không xác định';
              item.to_list_districtName = 'Không xác định';
              item.to_list_address = 'Không xác định';
              if (item.to_list_provinceName.length > 0) {
                item.to_list_provinceName = list_province_name.toString();
              }
              if (list_province_Id.length === 1) {
                const list_district_Id = item.location.item.districtIds;
                const list_district_name = [];
                this.getDistrictMap(list_province_Id[0]).then((districts) => {
                  if (districts.error === false) {
                    const data_districts = districts.data.districts;
                    data_districts.map((one_district) => {
                      if (list_district_Id.includes(one_district.id)) {
                        list_district_name.push(one_district.name);
                      }
                    });
                    if (list_district_name.length > 0) {
                      item.to_list_districtName = list_district_name.toString();
                    }
                  }
                });
                if (list_district_Id.length === 1) {
                  console.log('item.location', item.location);
                  item.to_list_address =
                    item.location.item.address !== null
                      ? item.location.item.address[0]
                      : '';
                }
              }
              return;
            }
            const keys = ['toProvince', 'toDistrict', 'toAddress'];
            keys.map((key) => {
              if (item[key] === null) {
                item[key] = 'Không xác định';
              }
            });
          });
          this.total_distribution = res.data.totalElement;
          if (res.data.totalElement && this.load_map_distrivution === true) {
            this.getAllHistoryDistribution();
          }
          console.log('this.toLocation', this.data_distribution)
          return;
        }
        this.data_distribution = [];
        this.total_distribution = 0;
      },
      (error) => {
        this.data_distribution = [];
        this.total_distribution = 0;
      }
    );
  }
  loadScanErrors() {
    this.checkStampService.getScanErr({
      serial: this.data.serial,
      page: this.pageIndexScanErr,
      page_size: this.pageSizeScanErr,
    }).subscribe(
      async (res) => {
        if (res.code === 1) {
          this.data_scan_errors = res.data.items;
          this.total_scan_errors = res.data.pagination.totalElements;
          console.log('this.toLocation', this.data_distribution)
          return;
        }
        this.data_distribution = [];
        this.total_scan_errors = 0;
      },
      (error) => {
        this.data_distribution = [];
        this.total_scan_errors = 0;
      }
    );
  }
  prePageScanErr() {
    if (this.pageIndexScanErr > 1) {
      this.pageIndexScanErr = this.pageIndexScanErr - 1;
      this.loadScanErrors();
    }
  }
  inputPageScanErr(event) {
    // tslint:disable-next-line:radix
    const page = parseInt(event.target.value);
    if (page % 1 === 0 && page > 0 && page !== this.pageIndexScanErr) {
      this.pageIndexScanErr = page;
      this.loadScanErrors();
    }
  }
  lastPageScanErr() {
    if (
      this.pageIndexScanErr * this.pageSizeScanErr <
      this.total_scan_errors
    ) {
      this.pageIndexScanErr = this.pageIndexScanErr + 1;
      this.loadScanErrors();
    }
  }
  prePageHistoryDistribution() {
    if (this.pageIndexDistribution > 1) {
      this.pageIndexDistribution = this.pageIndexDistribution - 1;
      this.load_map_distrivution = false;
      this.loadHistoryDistribution();
    }
  }

  inputPageHistoryDistributionChange(event) {
    // tslint:disable-next-line:radix
    const page = parseInt(event.target.value);
    if (page % 1 === 0 && page > 0 && page !== this.pageIndexDistribution) {
      this.pageIndexDistribution = page;
      this.load_map_distrivution = false;
      this.loadHistoryDistribution();
    }
  }

  lastPageHistoryDistribution() {
    if (
      this.pageIndexDistribution * this.pageSizeDistribution <
      this.total_distribution
    ) {
      this.pageIndexDistribution = this.pageIndexDistribution + 1;
      this.load_map_distrivution = false;
      this.loadHistoryDistribution();
    }
  }
  // =============== end lich su phan phoi ================= //
  // pageIndexGuarantee = 1;
  // pageSizeGuarantee = 10;
  // /** ------ Lịch sử bảo hành ------- */
  // loadHistoryGuarantee(){
  //   const body = {
  //     serial: this.data.serial,
  //     page: this.pageIndexGuarantee,
  //     pageSize: this.pageSizeGuarantee,
  //   };
  //   console.log(body.serial) ;
  //   this.checkStampService.getStampHistoryGuarantee(body.serial).subscribe(
  //     (res)=> {
  //       console.log("data mau :" + res.data);
  //     }
  //   )
  // }
  /** ------ End Lịch sử bảo hành ------- */


  /** ------ Lịch sử bảo hành ------- */
  pageIndexGuarantee = 1;
  pageSizeGuarantee = 10;
  public logs_of_serial: any = [];
  public serial_info: any = {};

  convert_guarantee_days(guarantee_days: number) {
    let time_format: string;
    if (guarantee_days % 365 == 0) {
      time_format = guarantee_days / 365 + ' năm';
    } else if (guarantee_days % 31 == 0) {
      time_format = guarantee_days / 31 + ' tháng';
    } else {
      time_format = guarantee_days + ' ngày';
    }
    return time_format;
  }


  convertDate(time?) {
    return time.split('T')[0]
  }
  showMoreHistoryNoteInProgress(logId: string, index: number) {
    this.logs_of_serial[index].historyUpdatedCurrentPage += 1;
    this.logs_of_serial[index].isLoadHistoryUpdate = false;
    this.currentLogId = '-1';
    this.getHistoryNoteInProgress(logId, index);
  }

  total_logs = 0;

  loadHistoryGuarantee() {
    let offset = this.pageSize * (this.currentPage <= 0 ? 0 : this.currentPage - 1);
    let limit = this.pageSize;
    const body = {
      serial: this.data.serial,
      page: this.pageIndexGuarantee,
      pageSize: this.pageSizeGuarantee,
    };
    this.checkStampService.getStampHistoryGuarantee(body.serial, { limit, offset, }).subscribe(
      (res) => {
        if (res.data && res.status == 200) {
          let serial_info = res.data.serial_info;
          this.total_logs = res.data.logs.length;
          this.totalPage = Math.ceil(this.total_logs / this.pageSize);
          console.log(this.totalPage);
          let check_serial_info = Object.getOwnPropertyNames(serial_info).length === 0;
          if (check_serial_info == false) {
            this.serial_info = {
              serial: body.serial,
              batch_name: serial_info.batch.name,
              produce_time: serial_info.batch.produce_time,
              produce_time_f: moment(serial_info.batch.produce_time).format(
                'DD/MM/YYYY'
              ),
              guarantee_days:
                serial_info.batch.guarantee_days > 0
                  ? this.convert_guarantee_days(serial_info.batch.guarantee_days)
                  : null,
              guarantee_days_max:
                serial_info.batch.guarantee_days_max > 0
                  ? this.convert_guarantee_days(
                    serial_info.batch.guarantee_days_max
                  )
                  : null,
              guarantee_days_update: serial_info.batch.guarantee_days_update,
              guarantee_days_max_update:
                serial_info.batch.guarantee_days_max_update,
              type_guarantee_day: serial_info.batch.type_guarantee_day,
              type_guarantee_day_max: serial_info.batch.type_guarantee_day_max,

              product_name: serial_info.product.name,
              active_time: serial_info.time.active_time,
              active_time_f: moment(serial_info.time.active_time).format(
                'DD/MM/YYYY'
              ),
              expired_time: serial_info.time.expired_time,
              expired_time_f: moment(serial_info.time.expired_time).format(
                'DD/MM/YYYY'
              ),
              is_expired:
                moment(serial_info.time.expired_time).format('YYYYMMDD') <=
                moment(new Date()).format('YYYYMMDD'),
            };
          }
        }
        /** ---- Xử lý lấy log ---- */
        let list_logs_of_serial = [];
        for (let log of res.data.logs) {
          let has_state = log.state && log.state.id && log.state.id > 0;
          if (log.fields) {
            for (let i = 0; i < log.fields.length; i++) {
              if (log.fields[i].value) {
                let stringValue = log.fields[i].value.split('\n');
                if (stringValue.length > 1) {
                  let listText: any = [];
                  for (let h = 0; h < stringValue.length; h++) {
                    listText.push(stringValue[h]);
                  }
                  log.fields[i]['haveEnter'] = true;
                  log.fields[i].value = listText;
                }
              }
            }
          }
          let obj: any;
          obj = {
            id: log._id,
            code: log.code,
            product_code: log.product_code,
            created_time: log.created_time,
            created_time_f: moment(log.created_time).format('DD/MM/YYYY'),
            updated_time: log.updated_time,
            updated_time_f: moment(log.updated_time).format('DD/MM/YYYY'),
            customer: log.customer,
            user_created: log.user_created,
            note: log.note,
            status: log.status.id,
            status_f: log.status.name,
            state: has_state ? log.state.id : null,
            state_f: has_state ? log.state.name : null,
            is_active: log.status.id == 1,
            is_receive: log.status.id == 5,
            is_wait: log.status.id == 2 && log.state.id == 6,
            is_reject: log.status.id == 2 && log.state.id == 4,
            is_done: log.status.id == 2 && log.state.id == 3,
            fields: log.status.id !== 2 && log.customer ? log.customer.fields : log.fields,
            type: log.type,
            images: log.images,
            variant: log.extra,
            historyUpdated: [],
            isLoadHistoryUpdate: false,
            historyUpdatedCurrentPage: 1,
            historyUpdatedTotal: 0,
          };
          list_logs_of_serial.push(obj);
        }
        this.logs_of_serial = list_logs_of_serial;
        console.log("data bao hanh: " + this.logs_of_serial.length);
      },
      (error) => {
        this.serial_info = {};
        this.logs_of_serial = [];
        // this.data_history_guarantee_logs =[];
      }
    )
  }
  // Phân trang
  setPage(page: number) {
    // alert(this.logs_of_serial.length);
    if (page < 1) {
      this.currentPage = 1;
    }
    if (page != this.currentPage) {
      this.currentPage = page;
      this.loadHistoryGuarantee();
    }
  }

  goPage2(toPage: any) {
    toPage = parseInt(toPage);
    if (toPage && toPage > 0) {
      this.setPage(toPage);
    }
  }

  _keyPress(event: any) {
    if (event.charCode !== 0) {
      const pattern = /[0-9]/;
      const inputChar = String.fromCharCode(event.charCode);

      if (!pattern.test(inputChar)) {
        // invalid character, prevent input
        event.preventDefault();
      }
    }
  }

  // Xem chi tiet
  modalRef: any;
  openActiveTemp(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
  }

  isShowNoteInProgressDialog: boolean = false;
  imagesNoteInProgress: any = [];
  noteInProgress: any = {};
  NoteInProgressPageSize: number = 3;
  currentLogId: string;

  // guarantee add note inprogress - show dialog update
  showNoteInProgressDialog() {
    this.isShowNoteInProgressDialog = true;
  }

  // xóa ảnh
  deleteImageNoteInProgress(id: number) {
    for (let i = 0; i < this.imagesNoteInProgress.length; i++) {
      if (this.imagesNoteInProgress[i].id === id) {
        this.imagesNoteInProgress.splice(
          this.imagesNoteInProgress.indexOf(this.imagesNoteInProgress[i]),
          1
        );
        break;
      }
    }
  }
  // guarantee add note inprogress - upload images
  tusUpload = (item: any) => {
    const numberImages = item.target.files.length;
    if (numberImages > 5) {
      this.toastr.error('Chỉ được upload tối đa 5 ảnh', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
    } else {
      for (const image of item.target.files) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const fileData = (<any>e.target).result;
          return this.upload.uploadImagesNew(fileData).subscribe((res) => {
            const image = {
              id: res.json().fileId,
              url: res.json().src,
            };
            if (this.imagesNoteInProgress.length >= 5) {
              this.toastr.error('Chỉ được upload tối đa 5 ảnh', '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
            } else {
              this.imagesNoteInProgress.push(image);
            }
          });
        };
        reader.readAsArrayBuffer(image);
      }
    }
  };

  submitNewUpdatedNoteGuarantee(logId: string, index: number) {
    if (this.noteInProgress.note.trim() == '') {
      this.toastr.error('Note không để trống', '', {
        timeOut: 2000,
        positionClass: 'toast-bottom-right',
      });
      this.noteInProgress.note = '';
      return;
    }
    let submitData = {
      note: this.noteInProgress.note.trim() || null,
      images: this.imagesNoteInProgress.map((item: any) => item.url),
    };
    this.stampService
      .createNewUpdatedNoteGuarantee(logId, submitData)
      .subscribe((res: any) => {
        if (!res.error) {
          this.toastr.success('Thêm mới cập nhật bảo hành thành công', '', {
            timeOut: 2000,
            positionClass: 'toast-bottom-right',
          });
          this.logs_of_serial[index].historyUpdated = [];
          this.isShowNoteInProgressDialog = false;
          this.currentLogId = '-1';
          this.logs_of_serial[index].historyUpdatedCurrentPage = 1;
          this.logs_of_serial[index].isLoadHistoryUpdate = false;
          this.noteInProgress.note = '';
          this.imagesNoteInProgress = [];
          this.loadHistoryGuarantee();
          this.getHistoryNoteInProgress(logId, index);
        } else {
          this.toastr.error('Thêm cập nhật bảo hành thất bại', '', {
            timeOut: 2000,
            positionClass: 'toast-bottom-right',
          });
        }
      });
  }
  // lấy danh sách lịch sử cập nhật bảo hành
  getHistoryNoteInProgress(logId: string, index: number) {
    // if (this.currentLogId == logId) {
    //   return;
    // } else {
    this.currentLogId = logId;
    // }

    if (this.logs_of_serial[index].isLoadHistoryUpdate) {
      return;
    }

    let opt = {
      limit: this.NoteInProgressPageSize,
      offset:
        this.NoteInProgressPageSize *
        (this.logs_of_serial[index].historyUpdatedCurrentPage <= 0
          ? 0
          : this.logs_of_serial[index].historyUpdatedCurrentPage - 1),
    };

    this.stampService
      .getListHistoryNoteInProgress(logId, opt)
      .subscribe((res: any) => {
        if (!res.error && res.data) {
          this.logs_of_serial[index].historyUpdatedTotal = res.data.logs.total;
          let tmpArr = res.data.logs.list.map((item: any) => {
            return {
              id: item._id,
              note: item.note,
              images: item.images,
              createdAt: item.created_at,
            };
          });
          this.logs_of_serial[index].historyUpdated = [
            ...this.logs_of_serial[index].historyUpdated,
            ...tmpArr,
          ];
          this.logs_of_serial[index].isLoadHistoryUpdate = true;
        }
      });
  }
  closeNoteInProgress() {
    this.isShowNoteInProgressDialog = !this.isShowNoteInProgressDialog;
    this.noteInProgress.note = '';
    this.imagesNoteInProgress = [];
  }


  // xử lí thêm note cho tiếp nhận/từ chối bảo hành
  status_guarantee: any = null;

  // add note to guarantee
  guarantee_note: string = '';
  guarantee_title_dialog: string = '';
  displayBasic: boolean;

  showBasicDialog(status) {
    switch (status) {
      case 3: {
        this.guarantee_title_dialog = 'hoàn thành bảo hành';
        this.status_guarantee = 3;
        break;
      }
      case 4: {
        this.guarantee_title_dialog = 'từ chối bảo hành';
        this.status_guarantee = 4;
        break;
      }
    }
    this.displayBasic = true;
  }
  updateStatus_1(status, i) {
    // let rq = this.logs_of_serial[i]
    // if(this.guarantee_note) {
    //   rq.note = this.guarantee_note
    // }
    // console.log(this.logs_of_serial[i]);
    this.stampService
      .updateGuaranteeStatusById(
        this.logs_of_serial[i].id,
        status,
        this.logs_of_serial[i]
      )
      .subscribe((res) => {
        if (!res.error) {
          this.toastr.info(
            'Đã chuyển trạng thái sang ' + this.guarantee_title_dialog,
            '',
            {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            }
          );
          // this.viewDetail(this.serial_info.serial, this.item_active);
        }
        this.displayBasic = false;


      });
    this.loadHistoryGuarantee();
  }

  /** ------ End Lịch sử bảo hành ------- */

  // =============== lich su quet =================== //

  loadHistoryScan() {
    const body = {
      serial: this.data.serial,
      owner: this.data.owner,
      page: this.pageIndexScan,
      pageSize: this.pageSizeScan,
    };
    this.checkStampService.getHistoryScanStampProduct(body).subscribe(
      (res) => {
        if (res.code === 1) {
          this.data_scan = res.data.items;
          this.total_scan = res.data.totalElement;
          return;
        }
        this.data_scan = [];
        this.total_scan = 0;
      },
      (error) => {
        this.data_scan = [];
        this.total_scan = 0;
      }
    );
  }

  prePageHistoryScan() {
    if (this.pageIndexScan > 1) {
      this.pageIndexScan = this.pageIndexScan - 1;
      this.loadHistoryScan();
    }
  }

  inputPageHistoryScanChange(event) {
    // tslint:disable-next-line:radix
    const page = parseInt(event.target.value);
    if (page % 1 === 0 && page > 0 && page !== this.pageIndexScan) {
      this.pageIndexScan = page;
      this.loadHistoryScan();
    }
  }

  lastPageHistoryScan() {
    if (this.pageIndexScan * this.pageSizeScan < this.total_scan) {
      this.pageIndexScan = this.pageIndexScan + 1;
      this.loadHistoryScan();
    }
  }

  // =============== end lich su quet ================ //

  onMouseOver(infoWindow, gm) {
    if (gm.lastOpen != null) {
      gm.lastOpen.close();
    }

    gm.lastOpen = infoWindow;

    infoWindow.open();
  }

  onMouseOut(infoWindow, gm) {
    infoWindow.close();
  }

  moveToMap() {
    $('html, body').animate({ scrollTop: 1300 }, 500);
  }

  changeTab(event) {
    this.activeTab = event;
    this.resetModalWarning();
  }

  openModalBlock() {
    this.note_block = undefined;
    this.disable_block = false;
    this.blockModal.show();
  }

  submitModalBlock() {
    if (!this.note_block) {
      this.toastr.error('Chưa nhập lý do khóa', 'Có lỗi xảy ra');
      return;
    }
    const batch_id = this.data.batchId;
    let serial = this.data.serial;
    serial = serial.split('-');
    this.disable_block = true;
    let id = serial[1];
    id = id.split('');
    let index = 0;
    for (let i = 0; i < id.length; i++) {
      // tslint:disable-next-line:radix
      if (parseInt(id[i]) !== 0) {
        index = id.indexOf(id[i]);
        break;
      }
    }
    // const id_start = serial[1].slice(index);
    const id_start = this.data.idStart;
    const body = {
      batch_id: batch_id,
      id_start: id_start,
      id_end: id_start,
      note: this.note_block.trim(),
      status: 1,
    };
    this.batchService.restoreStamp(body).subscribe(
      (res) => {
        this.disable_block = false;
        if (res.error === false) {
          this.toastr.success('Khóa tem thành công', 'Thông báo');
          this.blockModal.hide();
          return;
        }
        this.toastr.success(res.message, 'Khóa tem thất bại');
      },
      (error) => {
        this.disable_block = false;
        this.toastr.error(error.message, 'Khóa tem thất bại');
      }
    );
  }

  getTotalWarning(agencyId?: string) {
    return this.checkStampService.getTotalWarning(agencyId).toPromise();
  }

  getDetilAgency(id?: string) {
    return this.agencyService.getDetail(id).toPromise();
  }

  submitModalWarning() {
    const val = $('#agency').val();
    if (this.activeTab === 1) {
      if (!val) {
        this.valid_agency = true;
        return;
      }
      const body = {
        type: 0,
        // tslint:disable-next-line:radix
        provinceWarningId: parseInt(this.agency_detail.provinceId),
        // tslint:disable-next-line:radix
        districtWarningId: parseInt(this.agency_detail.districtId),
        wardWarningId: null,
        addressWarning: this.agency_detail.address,
        note: this.note_warning,
        // tslint:disable-next-line:radix
        agencyWarningId: parseInt(val),
        stampCode: this.data.serial,
        bundleType: 0,
      };
      this.body = body;
    }
    if (this.activeTab === 2) {
      const provinceId = $('#citiesProduct').val();
      const districtId = $('#districtProduct').val();
      if (!provinceId) {
        this.validProvinceId = true;
      }
      if (!districtId) {
        this.validDistrict = true;
      }
      if (!provinceId || !districtId) {
        return;
      }
      const body = {
        type: 1,
        // tslint:disable-next-line:radix
        provinceWarningId: parseInt(provinceId),
        // tslint:disable-next-line:radix
        districtWarningId: parseInt(districtId),
        wardWarningId: null,
        addressWarning: this.address,
        note: this.note_warning,
        bundleId: this.data.bundleId,
        // tslint:disable-next-line:radix
        agencyWarningId: null,
        bundleItemId: this.data.bundleItemId,
        stampCode: this.data.serial,
        bundleType: this.data.bundleType,

      };
      this.body = body;
    }
    this.disable_warning = true;
    this.checkStampService.createWarning(this.body).subscribe(
      (res) => {
        this.disable_warning = false;
        if (res.code === 1) {
          this.toastr.success('Tạo mới cảnh báo thành công', 'Thành công');
          this.checkWarning.hide();
          this.loadListWarning();
          this.after_create_warning = true;
          this.getAllWarningMarket();
          this.resetModalWarning();
          return;
        }
        this.toastr.error(res.message, 'Tạo mới cảnh báo thất bại');
      },
      (error) => {
        this.disable_warning = false;
        this.toastr.error(error.message, 'Tạo mới cảnh báo thất bại');
      }
    );
  }

  showModalWarning() {
    this.activeTab = 1;
    this.resetModalWarning();
    this.checkWarning.show();
  }

  closeModalWarning() {
    this.resetModalWarning();
    this.activeTab = 1;
    this.checkWarning.hide();
  }

  resetModalWarning() {
    this.valid_agency = false;
    this.warning_count = 0;
    this.warning_count = 0;
    this.note_warning = undefined;
    this.validDistrict = false;
    this.validProvinceId = false;
    this.address = undefined;
    $('#agency').val(null).trigger('change');
    $('#citiesProduct').val(null).trigger('change');
    $('#districtProduct').val(null).trigger('change');
  }

  getFromArea() {
    this.addressService.getCities().subscribe((res) => {
      const citiesList = [];
      res.data.cities.forEach((c: any) => {
        citiesList.push({
          value: c.name,
          label: c.name,
          id: c.id,
        });
      });
      this.cities = citiesList;
    });
  }

  getDistrict(id: number) {
    const query = {
      city_id: id,
    };
    this.addressService.getDistrict(query).subscribe(
      (res) => {
        if (res.status === 200) {
          const citiesList = [];
          const items = res.data.districts;
          items.map((item) => {
            citiesList.push({
              label: item.name,
              id: item.id,
            });
          });
          this.districts = citiesList;

          return;
        }
        this.districts = [];
      },
      (error) => {
        this.districts = [];
      }
    );
  }

  // ================ trả hàng ========================= //
  openModalReturn() {
    this.note_return = '';
    this.retutn.show();
  }

  closeModalReturn() {
    this.retutn.hide();
  }

  noteReturnChange() {
    this.valid_note_return = false;
  }

  submitModalReturn() {
    this.valid_note_return = false;
    if (!this.note_return) {
      this.valid_note_return = true;
      return;
    }
    let serial = this.data.serial;
    serial = serial.split('-');
    // if (serial && serial.length === 2) {
    this.disable_block = true;
    let id = serial[1];
    id = id.split('');
    let index = 0;
    for (let i = 0; i < id.length; i++) {
      // tslint:disable-next-line:radix
      if (parseInt(id[i]) !== 0) {
        index = id.indexOf(id[i]);
        break;
      }
    }
    // const id_start = serial[1].slice(index);
    const id_start = this.data.idStart;
    const body = {
      listData: [
        {
          type: 0,
          prefix: this.data.prefix,
          idStart: id_start,
          idEnd: id_start,
          note: this.note_return,
        },
      ],
    };
    this.checkStampService.createReturnStamp(body).subscribe(
      (res) => {
        if (res.code === 1) {
          this.toastr.success(
            "Tạo mới yêu cầu trả tem thành công" +
            `<div>Thành công: <b>${res.data.success}</b>, Thất bại: <b>${res.data.fail}</b></div>`,
            "Thành công",

            {
              timeOut: 3000,
              positionClass: 'toast-top-right',
              enableHtml: true,
            }
          );
          this.closeModalReturn();
          return;
        }
        this.toastr.error(res.message, 'Thất bại');
      },
      (error) => {
        this.toastr.error(error.message, 'Thất bại');
      }
    );
    // }
  }

  // ================ end trả hàng ===================== //

  // ================ phan phoi =================== //

  changeDistribution() {
    this.isDistribution = true;
    this.isList = false;
    setTimeout(() => {
      this.boxStampDistribution.setData(
        this.data.serial,
        this.data.bundleType,
        true
      );
    }, 500);
  }

  hideComponentDistribuiton(event) {
    this.isDistribution = false;
    this.isList = true;
  }

  getAllHistoryDistribution() {
    const body = {
      page: 1,
      serial: this.data.serial,
      page_size: this.total_distribution,
      owner: this.data.owner,
    };
    this.data_map = [];
    this.checkStampService.getStampHistory(body).subscribe((res) => {
      if (res.code === 1) {
        const items = res.data.items;
        const data = [];
        for (let i = items.length - 1; i >= 0; i--) {
          data.push(items[i]);
        }
        this.getMapFromLatLng(data);
      }
    });
  }

  getMapFromLatLng(data?: any[]) {
    console.log('19998899', data)
    data.map(async (item, index) => {
      const type = [];
      if (item.userScanWarning) {
        type.push(0);
      }
      if (item.warning) {
        type.push(1);
      }
      let color;
      switch (item.transferType) {
        case 0: {
          color = 'blue';
          break;
        }
        case 1: {
          color = '#f00';
          break;
        }
        case 2: {
          color = '#BDBDBD';
          break;
        }
      }
      const object = {
        origin: undefined,
        destination: undefined,
        renderOptions: undefined,
      };
      if (item.transferType === 1 || item.transferType === 2) {
        object.renderOptions = {
          polylineOptions: { strokeColor: `${color}`, strokeWeight: 5 },
        };
      }
      // tslint:disable-next-line:max-line-length
      const address_from =
        (item.fromAddress !== null ? item.fromAddress : '') +
        ' ' +
        (item.fromDistrict !== null ? item.fromDistrict : '') +
        ' ' +
        (item.fromProvince !== null ? item.fromProvince : '');
      const query_from = {
        input: address_from,
        api_key: 'vMM2QATcZwsZVUtu0UM201n4RR6qVo58w4QjXFMq',
      };
      const obj_from = item.fromLocation;
      this.lng = obj_from.lng;
      this.lat = obj_from.lat;
      object.origin = obj_from;
      console.log(33333, object.origin)
      // await this.getPlaceId(query_from).then((place_id_from) => {
      //   if (place_id_from.status === 'OK') {
      //     const place_id = place_id_from.predictions[0].place_id;
      //     this.getLatLon(place_id).then((latlon_from) => {
      //       if (latlon_from.status === 'OK') {
      //         const obj_from = {
      //           lat: latlon_from.result.geometry.location.lat,
      //           lng: latlon_from.result.geometry.location.lng,
      //         };
      //         this.lng = latlon_from.result.geometry.location.lng;
      //         this.lat = latlon_from.result.geometry.location.lat;
      //         object.origin = obj_from;
      //       }
      //     });
      //   }
      // });
      // get Lat lon theo dia chi
      if (
        item.toProvince !== null ||
        item.toDistrict !== null ||
        item.toAddress !== null
      ) {
        // tslint:disable-next-line:max-line-length
        const address_to =
          (item.toAddress !== null ? item.toAddress : '') +
          ' ' +
          (item.toDistrict !== null ? item.toDistrict : '') +
          ' ' +
          (item.toProvince !== null ? item.toProvince : '');
        const query_to = {
          input: address_to,
          api_key: 'vMM2QATcZwsZVUtu0UM201n4RR6qVo58w4QjXFMq',
        };
        const obj = item.toLocation;

        const a = {
          origin: object.origin,
          destination: obj,
          renderOptions: object.renderOptions,
        };
        this.data_map.push(a);
        const market = {
          lat: obj.lat,
          lng: obj.lng,
          label: `${item.toProvince},${item.toAddress}`,
          icon: {
            url: undefined,
            scaledSize: {
              height: 30,
              width: 30,
            },
          },
          type: [],
          agency: undefined,
        };
        market.agency = item.toAgency !== null ? item.toAgency.trim() : '';
        if (type.length === 1) {
          type.map((item_type) => {
            // tslint:disable-next-line:radix
            if (parseInt(item_type) === 0) {
              market.icon.url =
                'https://image.flaticon.com/icons/svg/1277/1277612.svg';
              market.type = [0];
            }
            // tslint:disable-next-line:radix
            if (parseInt(item_type) === 1) {
              market.icon.url =
                'https://image.flaticon.com/icons/svg/3325/3325026.svg';
              market.type = [1];
            }
            this.data_map_warning.push(market);
          });
        }
        if (type.length === 2) {
          if (type.includes(0) && type.includes(1)) {
            market.icon.url =
              'https://image.flaticon.com/icons/svg/1277/1277612.svg';
            market.type = [0, 1];
          }
          this.data_map_warning.push(market);
        }
        // this.getPlaceId(query_to).then((place_id_data) => {
        //   if (place_id_data.status === 'OK') {
        //     const place_id = place_id_data.predictions[0].place_id;
        //     this.getLatLon(place_id).then((latlon_to_case_one_province) => {
        //       if (latlon_to_case_one_province.status === 'OK') {
        //         const obj = {
        //           lat: latlon_to_case_one_province.result.geometry.location.lat,
        //           lng: latlon_to_case_one_province.result.geometry.location.lng,
        //         };
        //         const a = {
        //           origin: object.origin,
        //           destination: obj,
        //           renderOptions: object.renderOptions,
        //         };
        //         this.data_map.push(a);
        //         const market = {
        //           lat: latlon_to_case_one_province.result.geometry.location.lat,
        //           lng: latlon_to_case_one_province.result.geometry.location.lng,
        //           label: `${latlon_to_case_one_province.result.name},${latlon_to_case_one_province.result.formatted_address}`,
        //           icon: {
        //             url: undefined,
        //             scaledSize: {
        //               height: 30,
        //               width: 30,
        //             },
        //           },
        //           type: [],
        //           agency: undefined,
        //         };
        //         market.agency =
        //           item.toAgency !== null ? item.toAgency.trim() : '';
        //         if (type.length === 1) {
        //           type.map((item_type) => {
        //             // tslint:disable-next-line:radix
        //             if (parseInt(item_type) === 0) {
        //               market.icon.url =
        //                 'https://image.flaticon.com/icons/svg/1277/1277612.svg';
        //               market.type = [0];
        //             }
        //             // tslint:disable-next-line:radix
        //             if (parseInt(item_type) === 1) {
        //               market.icon.url =
        //                 'https://image.flaticon.com/icons/svg/3325/3325026.svg';
        //               market.type = [1];
        //             }
        //             this.data_map_warning.push(market);
        //           });
        //         }
        //         if (type.length === 2) {
        //           if (type.includes(0) && type.includes(1)) {
        //             market.icon.url =
        //               'https://image.flaticon.com/icons/svg/1277/1277612.svg';
        //             market.type = [0, 1];
        //           }
        //           this.data_map_warning.push(market);
        //         }
        //       }
        //     });
        //   }
        // });
        return;
      }
      // get lat lon theo id
      const locationTo = item.location.item;
      const provinces = locationTo.provinceIds;
      const arr = [];
      // case 1 tinh
      // if (provinces.length === 1) {
      // const provinceId = provinces[0];
      // let provinceName = '';
      // this.cities.map((city) => {
      //   if (city.id === provinceId) {
      //     provinceName = city.value;
      //   }
      // });
      // let district_list = [];
      // await this.getDistrictMap(provinceId).then((district) => {
      //   if (district.error === false) {
      //     district_list = district.data.districts;
      //   }
      // });
      // let locationToConverted = [];
      // const districts_to = locationTo.districtIds;
      // if (districts_to.length > 0) {
      //   const districts_to_name = [];
      //   if (districts_to.length) {
      //     districts_to.map((d) => {
      //       district_list.map((di) => {
      //         if (di.id === d) {
      //           districts_to_name.push(di.name);
      //         }
      //       });
      //     });
      //   }
      //   districts_to_name.map((i) => {
      //     const location = `${i} ${provinceName}`;
      //     locationToConverted.push(location);
      //   });
      //   if (locationToConverted.length === 1) {
      //     locationToConverted.map((l) => {
      //       locationToConverted = [];
      //       locationToConverted = [`${locationTo.address} ${l}`];
      //     });
      //   }
      // }
      // if (districts_to.length === 0) {
      //   const address$ = locationTo.address;
      //   if (address$.length > 0) {
      //     locationToConverted = [`${address$[0]} ${provinceName}`];
      //   } else {
      //     locationToConverted = [`${provinceName}`];
      //   }
      // }
      // tslint:disable-next-line:no-shadowed-variable
      console.log('item.districtLocations', item.districtLocations)
      let locationData = item.districtLocations.length > 0 && item.districtLocations[0].lat ? item.districtLocations : item.provinceLocations;

      locationData.map((val) => {
        const obj = {
          lat: val.lat,
          lng: val.lon,
        };
        console.log(obj)
        const market = {
          lat: obj.lat,
          lng: obj.lng,
          label: `${val.name}`,
          icon: {
            url: undefined,
            scaledSize: {
              height: 30,
              width: 30,
            },
          },
          type: [],
          agency: undefined,
        };

        if (type.length === 1) {
          type.map((item_type) => {
            // tslint:disable-next-line:radix
            if (parseInt(item_type) === 0) {
              market.icon.url =
                'https://image.flaticon.com/icons/svg/1277/1277612.svg';
              market.type = [0];
            }
            // tslint:disable-next-line:radix
            if (parseInt(item_type) === 1) {
              market.icon.url =
                'https://image.flaticon.com/icons/svg/3325/3325026.svg';
              market.type = [1];
            }
            this.data_map_warning.push(market);
          });
        }
        if (type.length === 2) {
          if (type.includes(0) && type.includes(1)) {
            market.icon.url =
              'https://image.flaticon.com/icons/svg/1277/1277612.svg';
            market.type = [0, 1];
          }
          this.data_map_warning.push(market);
        }
        arr.push(obj)
      })


      // locationToConverted.map((l, index) => {
      //   arr.push(
      //     new Promise((resolve, reject) => {
      //       const query_to = {
      //         input: l,
      //         api_key: 'vMM2QATcZwsZVUtu0UM201n4RR6qVo58w4QjXFMq',
      //       };
      //       const get_placeId_to = this.getPlaceId(query_to);
      //       get_placeId_to.then((placeId) => {
      //         if (placeId.status === 'OK') {
      //           const place_id = placeId.predictions[0].place_id;
      //           this.getLatLon(place_id).then((latlon) => {
      //             if (latlon.status === 'OK') {
      //               const obj = {
      //                 lat: latlon.result.geometry.location.lat,
      //                 lng: latlon.result.geometry.location.lng,
      //               };
      //               const market = {
      //                 lat: latlon.result.geometry.location.lat,
      //                 lng: latlon.result.geometry.location.lng,
      //                 label: `${latlon.result.name},${latlon.result.formatted_address}`,
      //                 icon: {
      //                   url: undefined,
      //                   scaledSize: {
      //                     height: 30,
      //                     width: 30,
      //                   },
      //                 },
      //                 type: [],
      //                 agency: undefined,
      //               };
      //               if (type.length === 1) {
      //                 type.map((item_type) => {
      //                   // tslint:disable-next-line:radix
      //                   if (parseInt(item_type) === 0) {
      //                     market.icon.url =
      //                       'https://image.flaticon.com/icons/svg/1277/1277612.svg';
      //                     market.type = [0];
      //                   }
      //                   // tslint:disable-next-line:radix
      //                   if (parseInt(item_type) === 1) {
      //                     market.icon.url =
      //                       'https://image.flaticon.com/icons/svg/3325/3325026.svg';
      //                     market.type = [1];
      //                   }
      //                   this.data_map_warning.push(market);
      //                 });
      //               }
      //               if (type.length === 2) {
      //                 if (type.includes(0) && type.includes(1)) {
      //                   market.icon.url =
      //                     'https://image.flaticon.com/icons/svg/1277/1277612.svg';
      //                   market.type = [0, 1];
      //                 }
      //                 this.data_map_warning.push(market);
      //               }
      //               resolve(obj);
      //             }
      //           });
      //         }
      //       });
      //     })
      //   );
      // });
      Promise.all(arr).then((data_finally) => {
        data_finally.map((one_data) => {
          const a = {
            origin: object.origin,
            destination: one_data,
            renderOptions: object.renderOptions,
          };
          this.data_map.push(a);
        });
      });
      return;
      // }
      // case nhieu tinh
      // const list_province_name = [];
      // await provinces.map((pro) => {
      //   this.cities.map((ci) => {
      //     if (ci.id === pro) {
      //       list_province_name.push(ci.value);
      //     }
      //   });
      // });
      // list_province_name.map((pro_name) => {
      //   arr.push(
      //     new Promise((resolve, reject) => {
      //       const query_from_case_multiple_province = {
      //         input: pro_name,
      //         api_key: 'vMM2QATcZwsZVUtu0UM201n4RR6qVo58w4QjXFMq',
      //       };
      //       this.getPlaceId(query_from_case_multiple_province).then(
      //         (place_id_from) => {
      //           if (place_id_from.status === 'OK') {
      //             const place_id = place_id_from.predictions[0].place_id;
      //             this.getLatLon(place_id).then((latlon) => {
      //               if (latlon.status === 'OK') {
      //                 const obj = {
      //                   lat: latlon.result.geometry.location.lat,
      //                   lng: latlon.result.geometry.location.lng,
      //                 };
      //                 const market = {
      //                   lat: latlon.result.geometry.location.lat,
      //                   lng: latlon.result.geometry.location.lng,
      //                   label: `${latlon.result.name},${latlon.result.formatted_address}`,
      //                   icon: {
      //                     url: undefined,
      //                     scaledSize: {
      //                       height: 30,
      //                       width: 30,
      //                     },
      //                   },
      //                   type: [],
      //                   agency: undefined,
      //                 };
      //                 if (type.length === 1) {
      //                   type.map((item_type) => {
      //                     // tslint:disable-next-line:radix
      //                     if (parseInt(item_type) === 0) {
      //                       market.icon.url =
      //                         'https://image.flaticon.com/icons/svg/1277/1277612.svg';
      //                       market.type = [0];
      //                     }
      //                     // tslint:disable-next-line:radix
      //                     if (parseInt(item_type) === 1) {
      //                       market.icon.url =
      //                         'https://image.flaticon.com/icons/svg/3325/3325026.svg';
      //                       market.type = [1];
      //                     }
      //                     this.data_map_warning.push(market);
      //                   });
      //                 }
      //                 if (type.length === 2) {
      //                   if (type.includes(0) && type.includes(1)) {
      //                     market.icon.url =
      //                       'https://image.flaticon.com/icons/svg/1277/1277612.svg';
      //                     market.type = [0, 1];
      //                   }
      //                   this.data_map_warning.push(market);
      //                 }
      //                 resolve(obj);
      //               }
      //             });
      //           }
      //         }
      //       );
      //     })
      //   );
      // });
      // Promise.all(arr).then((data_finally) => {
      //   data_finally.map((one_data) => {
      //     const a = {
      //       origin: object.origin,
      //       destination: one_data,
      //       renderOptions: object.renderOptions,
      //     };
      //     this.data_map.push(a);
      //   });
      // });
    });
  }

  getAllWarningMarket() {
    this.warningInspection
      .getList({
        page: 1,
        page_size: !this.after_create_warning
          ? this.total_warning
          : this.total_warning + 1,
        serial: this.data.serial,
      })
      .subscribe((res) => {
        if (res.code === 1) {
          const items = res.data.items;
          const arr_promise = [];
          items.map((item, index) => {
            if (this.after_create_warning === true && index !== 0) {
              return;
            }
            arr_promise.push(
              new Promise((resolve, reject) => {
                // canh bao toi dai ly
                // tslint:disable-next-line:max-line-length
                const address =
                  (item.addressWarning !== null
                    ? item.addressWarning + ' '
                    : '') +
                  (item.districtWarning !== null
                    ? item.districtWarning + ' '
                    : '') +
                  (item.provinceWarning !== null ? item.provinceWarning : '');
                const query = {
                  input: address,
                  api_key: 'vMM2QATcZwsZVUtu0UM201n4RR6qVo58w4QjXFMq',
                };
                console.log('item333', item)
                const nameAgency =
                  item.agencyWarning !== null ? item.agencyWarning : '';
                const market = {
                  lat: item.location.lat,
                  lng: item.location.lng,
                  // tslint:disable-next-line:max-line-length
                  label: `${item.provinceWarning},${item.districtWarning}`,
                  icon: {
                    url:
                      'https://image.flaticon.com/icons/svg/196/196759.svg',
                    scaledSize: {
                      height: 30,
                      width: 30,
                    },
                  },
                  type: [2],
                  agency: nameAgency,
                };
                resolve(market);
                // this.getPlaceId(query).then((place) => {
                //   if (place.status === 'OK') {
                //     const place_id = place.predictions[0].place_id;
                //     this.getLatLon(place_id).then(async (latlon) => {
                //       if (latlon.status === 'OK') {
                //         const nameAgency =
                //           item.agencyWarning !== null ? item.agencyWarning : '';
                //         const market = {
                //           lat: latlon.result.geometry.location.lat,
                //           lng: latlon.result.geometry.location.lng,
                //           // tslint:disable-next-line:max-line-length
                //           label: `${latlon.result.name},${latlon.result.formatted_address}`,
                //           icon: {
                //             url:
                //               'https://image.flaticon.com/icons/svg/196/196759.svg',
                //             scaledSize: {
                //               height: 30,
                //               width: 30,
                //             },
                //           },
                //           type: [2],
                //           agency: nameAgency,
                //         };
                //         resolve(market);
                //       }
                //     });
                //   }
                // });
              })
            );
          });
          Promise.all(arr_promise).then((data_market) => {
            if (this.after_create_warning === false) {
              // loai bo cac điểm cảnh báo trùng nhau
              const data_market_finish = [];
              data_market.map(async (mar) => {
                if (data_market_finish.length === 0) {
                  data_market_finish.push(mar);
                  return;
                }
                let not_in = false;
                data_market_finish.map(async (i) => {
                  if (i.lat === mar.lat && i.lng === mar.lng) {
                    not_in = true;
                  }
                });
                if (!not_in) {
                  data_market_finish.push(mar);
                }
              });
              if (this.data_map_warning.length === 0) {
                data_market_finish.map((data$) => {
                  this.data_map_warning.push(data$);
                  return;
                });
              } else {
                data_market_finish.map(async (data$) => {
                  let not_in_data_warning = false;
                  this.data_map_warning.map(async (i_of_data) => {
                    if (
                      i_of_data.lat === data$.lat &&
                      i_of_data.lng === data$.lng
                    ) {
                      not_in_data_warning = true;
                    }
                  });
                  if (!not_in_data_warning) {
                    await this.data_map_warning.push(data$);
                  } else {
                    this.data_map_warning.map((item_duplicate) => {
                      if (
                        item_duplicate.lat === data$.lat &&
                        item_duplicate.lng === data$.lng &&
                        !item_duplicate.type.includes(2)
                      ) {
                        item_duplicate.type.push(2);
                        if (item_duplicate.agency !== data$.agency) {
                          item_duplicate.agency = `${item_duplicate.agency},${data$.agency}`;
                        }
                      }
                    });
                  }
                });
              }
              this.data_map_warning.map((item_convert) => {
                let label = '';
                const typeOfMarket = item_convert.type;
                if (typeOfMarket.length === 1) {
                  if (typeOfMarket.includes(0)) {
                    label = 'Địa điểm bị cảnh báo từ người dùng';
                  }
                  if (typeOfMarket.includes(1)) {
                    label = 'Địa điểm bị cảnh báo tự động';
                  }
                  if (typeOfMarket.includes(2)) {
                    label = 'Địa điểm bị cảnh báo từ kiểm tra thị trường';
                  }
                }
                if (typeOfMarket.length === 2) {
                  if (typeOfMarket.includes(0) && typeOfMarket.includes(1)) {
                    label = 'Địa điểm bị cảnh báo từ người dùng và tự động';
                  }
                  if (typeOfMarket.includes(0) && typeOfMarket.includes(2)) {
                    label =
                      'Địa điểm bị cảnh báo từ người dùng và kiểm tra thị trường';
                  }
                  if (typeOfMarket.includes(1) && typeOfMarket.includes(2)) {
                    label =
                      'Địa điểm bị cảnh báo tự động và kiểm tra thị trường';
                  }
                }
                if (typeOfMarket.length === 3) {
                  label =
                    'Địa điểm bị cảnh báo từ người dùng,tự động và kiểm tra thị trường';
                }
                if (item_convert.agency) {
                  const to_agency = `${item_convert.agency}.Địa chỉ:`;
                  item_convert.label = `${label}:${to_agency}${item_convert.label} `;
                } else {
                  item_convert.label = `${label}.Địa chỉ:${item_convert.label} `;
                }
              });
              return;
            }
            if (this.after_create_warning === true) {
              data_market.map((one_data_market) => {
                let label$ = '';
                if (one_data_market.agency) {
                  label$ = `Địa điểm bị cảnh báo từ kiểm tra thị trường:${one_data_market.agency}.Địa chỉ:${one_data_market.label}`;
                } else {
                  label$ = `Địa điểm bị cảnh báo từ kiểm tra thị trường.Địa chỉ:${one_data_market.label}`;
                }
                one_data_market.label = label$;
                this.data_map_warning.push(one_data_market);
              });
            }
          });
          return;
        }
      });
  }

  // getPlaceId(query?: any) {
  //   return this.checkStampService.getPalceId(query).toPromise();
  // }
  //
  // getLatLon(place_id?: string) {
  //   const query = {
  //     placeid: place_id,
  //     api_key: 'vMM2QATcZwsZVUtu0UM201n4RR6qVo58w4QjXFMq',
  //   };
  //   return this.checkStampService.getLatLon(query).toPromise();
  // }

  // =============== ds cnah bao tu kiem tra thi truong =============== //
  loadListWarning() {
    this.queryWarning = {
      serial: this.data.serial,
      agencyId: '',
      provinceId: '',
      districtId: '',
      wardId: '',
      from: '',
      to: '',
      page: this.pageIndexWarning,
      page_size: this.pageSizeWarning,
    };
    this.checkStampService.getWarningMarket(this.queryWarning).subscribe(
      (res) => {
        if (res.code === 1) {
          this.data_warning = res.data.items;
          this.total_warning = res.data.totalElement;
          return;
        }
        this.data_warning = [];
        this.total_warning = 0;
      },
      (error) => {
        this.data_warning = [];
        this.total_warning = 0;
      }
    );
  }

  prePageWarning() {
    if (this.pageIndexWarning > 1) {
      this.pageIndexWarning = this.pageIndexWarning - 1;
      this.loadListWarning();
    }
  }

  inputPageWarningChange(event) {
    // tslint:disable-next-line:radix
    const page = parseInt(event.target.value);
    if (page % 1 === 0 && page > 0 && page !== this.pageIndexWarning) {
      this.pageIndexWarning = page;
      this.loadListWarning();
    }
  }

  lastPageWarning() {
    if (this.pageIndexWarning * this.pageSizeWarning < this.total_warning) {
      this.pageIndexWarning = this.pageIndexWarning + 1;
      this.loadListWarning();
    }
  }

  // =============== end ds canh bao ====================== //
  async getDistrictMap(id: number) {
    const query = {
      city_id: id,
    };
    return await this.addressService.getDistrict(query).toPromise();
  }

  formatSerial(number, prefix: string = '') {
    let format_serial: string;
    let prefix2 = prefix ? prefix + '-' : '';
    number = number.toString();
    if (number.length > 6) {
      format_serial = prefix2 + number;
    } else {
      let pad = '000000';
      format_serial = prefix2 + pad.substring(0, 6 - number.length) + number;
    }
    return format_serial;
  }

  protected readonly JSON = JSON;
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/stamp_list/stamp-product/stamp-product.component.ts